import React, { useEffect, useState } from 'react'
import Utils from '../utility/utility';

/* Seconds worked today, as of `now` (unix seconds): every closed session, the
   open one up to now, less the day's break - and never below zero.

   The old timer folded the break into a fake start time
   (open start - closed sessions + break) and counted from there. Before that
   much time had been worked the fake start was in the future, so the clock
   ran backwards through negative numbers ("00:-33:-55"). The break is taken
   off the day only up to what has been worked, the same rule the backend's
   daily-clock-view applies to todayTime and weekTime. */
export const workedSeconds = (sessions, breakTime, now) => {
    let seconds = 0;
    (sessions ?? []).forEach((session) => {
        const start = Number(session?.start_time) || 0;
        if (!start) return;
        const end = Number(session?.end_time) || 0;
        seconds += (end || now) - start;
    });
    const [hours, minutes] = String(breakTime?.break ?? '').split(':');
    const breakSeconds = (parseInt(hours) || 0) * 3600 + (parseInt(minutes) || 0) * 60;
    return Math.max(0, seconds - breakSeconds);
}

/* A full day is nine hours of work with the break not counted - the same line
   the timelog draws between "Completed" and "Not completed"
   (views/timelog/timelogTone.js). */
export const WORKDAY_SECONDS = 9 * 3600;

/* When today's nine hours will be done (unix seconds), or null when no session
   is open. Only the open session is still counting, so the answer holds still
   while it runs: now plus what is left. A break is only recorded at clock-out,
   so one taken later today moves the time on by its own length. */
export const clockOutAt = (sessions, breakTime, now) => {
    if (!(sessions ?? []).some((session) => Number(session?.start_time) && !session?.end_time)) {
        return null;
    }
    return now + Math.max(0, WORKDAY_SECONDS - workedSeconds(sessions, breakTime, now));
}

export const nowSeconds = () => Math.floor(Date.now() / 1000);

const TaskTracker = ({ startTime, breakTime }) => {
    const [now, setNow] = useState(nowSeconds);

    // one interval for the life of the component, cleared on unmount - the old
    // effect had no dependency list and no cleanup, so every render started
    // another interval that was never stopped
    useEffect(() => {
        const id = setInterval(() => setNow(nowSeconds()), 1000);
        return () => clearInterval(id);
    }, []);

    return (
        <p className="text-big">
            {Utils.getHoursFromSeconds(workedSeconds(startTime, breakTime, now))}
        </p>
    )
}

export default TaskTracker
